<template>
  <div class="container-form margin-top-30">
    <h4 class="section-name-form">Reprezentant legal</h4>
    <p class="section-description-form">Datele reprezentantului legal vor apărea în contract</p>
    <div class="row">
      <div class="col-md-3 margin-top-15">
        <form-selector
          :selectLabel="appellativeLabel"
          selectName="appellative-list"
          :selectedOption="appellative"
          :options="appellatives"
          :selectValue="setAppellative"
          :error-text="appellativeInvalid"
          :isValid="validAppellative"
        ></form-selector>
      </div>
      <div class="col-md-9 margin-top-15">
        <form-selector
          :selectLabel="positionLabel"
          selectName="position-list"
          :selectedOption="position"
          :options="positions"
          :selectValue="setPosition"
          :error-text="positionInvalid"
          :isValid="validPosition"
        ></form-selector>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 margin-top-15">
        <form-input
          input-type="text"
          input-name="first-name"
          :input-label="firstNameLabel"
          :input-value="firstName"
          :setInput="setFirstName"
          :is-valid="validFirstName"
          :disabled="false"
          :error-text="firstNameInvalid"
        ></form-input>
      </div>
      <div class="col-md-6 margin-top-15">
        <form-input
          input-type="text"
          input-name="last-name"
          :input-label="lastNameLabel"
          :input-value="lastName"
          :setInput="setLastName"
          :is-valid="validLastName"
          :disabled="false"
          :error-text="lastNameInvalid"
        ></form-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 margin-top-15">
        <form-input
          input-name="email"
          input-type="email"
          :input-label="emailLabel"
          :input-value="email"
          :setInput="setEmail"
          :is-valid="validEmail"
          :disabled="false"
          :error-text="emailInvalid"
        ></form-input>
      </div>
      <div class="col-md-6 margin-top-15">
        <form-input
          input-type="text"
          input-name="phone"
          :input-label="phoneLabel"
          :input-value="phone"
          :setInput="setPhone"
          :is-valid="validPhone"
          :disabled="false"
          :error-text="phoneInvalid"
        ></form-input>
      </div>
    </div>
    <div class="row margin-top-30">
      <div class="col-md-12">
        <h4 class="section-name-form">Alte persoane de contact</h4>
        <p
          class="section-description-form"
        >Poți adăuga un responsabil pentru corespondența cu curierul, cât și toate persoanele care vrei să primească informări din partea noastră</p>
        <button-icon
          v-if="!hasContact"
          buttonClass="btn-contact"
          button-text=" adaugă un contact nou"
          icon-name="add"
          :on-click="toggleHasContact"
        ></button-icon>
        <button-icon
          v-if="hasContact"
          buttonClass="btn-contact"
          button-text=" șterge contact nou"
          icon-name="remove"
          :on-click="removeContact"
        ></button-icon>
      </div>
    </div>
    <div v-if="hasContact">
      <div class="row margin-top-30">
        <div class="col-md-12">
          <p class="add-new-contact">Adaugă un contact nou</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 margin-top-15">
          <form-selector
            :selectLabel="appellativeLabel"
            selectName="contact-appellative-list"
            :selectedOption="contactAppellative"
            :options="appellatives"
            :selectValue="setContactAppellative"
            :error-text="appellativeInvalid"
            :isValid="validContactAppellative"
          ></form-selector>
        </div>
        <div class="col-md-9 margin-top-15">
          <form-selector
            :selectLabel="positionLabel"
            selectName="contact-position-list"
            :selectedOption="contactPosition"
            :options="positions"
            :selectValue="setContactPosition"
            :error-text="positionInvalid"
            :isValid="validContactPosition"
          ></form-selector>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 margin-top-15">
          <form-input
            input-type="text"
            input-name="contact-first-name"
            :input-label="firstNameLabel"
            :input-value="contactFirstName"
            :setInput="setContactFirstName"
            :is-valid="validContactFirstName"
            :disabled="false"
            :error-text="firstNameInvalid"
          ></form-input>
        </div>
        <div class="col-md-6 margin-top-15">
          <form-input
            input-type="text"
            input-name="contact-last-name"
            :input-label="lastNameLabel"
            :input-value="contactLastName"
            :setInput="setContactLastName"
            :is-valid="validContactLastName"
            :disabled="false"
            :error-text="lastNameInvalid"
          ></form-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 margin-top-15">
          <form-input
            input-type="text"
            input-name="contact-email"
            :input-label="emailLabel"
            :input-value="contactEmail"
            :setInput="setContactEmail"
            :is-valid="validContactEmail"
            :disabled="false"
            :error-text="emailInvalid"
          ></form-input>
        </div>
        <div class="col-md-6 margin-top-15">
          <form-input
            input-type="text"
            input-name="contact-phone"
            :input-label="phoneLabel"
            :input-value="contactPhone"
            :setInput="setContactPhone"
            :is-valid="validContactPhone"
            :disabled="false"
            :error-text="phoneInvalid"
          ></form-input>
        </div>
      </div>
    </div>
    <div class="align-button-form margin-top-30">
      <button-form button-name="PASUL URMĂTOR" :on-click="nextStep"></button-form>
    </div>
  </div>
</template>

<script>
import FormSelector from "../global/FormSelector";
import FormInput from "../global/FormInput";
import ButtonIcon from "../global/ButtonIcon";
import ButtonForm from "../global/ButtonForm";
import { Appellatives, Positions } from "../../content/SelectLists";
import { GENERAL_INVALID } from "../../content/FormErrors";
import {
  APPELLATIVE_LABEL,
  POSITION_LABEL,
  FIRST_NAME_LABEL,
  LAST_NAME_LABEL,
  EMAIL_LABEL,
  PHONE_LABEL
} from "../../content/FormLabels";
import { mapMutations, mapState } from "vuex";
import { isNumber, notNull, validateEmail } from "../../helpers/Validations";

export default {
  components: {
    FormSelector,
    FormInput,
    ButtonIcon,
    ButtonForm
  },
  data() {
    return {
      appellatives: Appellatives,
      appellativeInvalid: GENERAL_INVALID,
      appellativeLabel: APPELLATIVE_LABEL,
      positions: Positions,
      positionInvalid: GENERAL_INVALID,
      positionLabel: POSITION_LABEL,
      firstNameInvalid: GENERAL_INVALID,
      firstNameLabel: FIRST_NAME_LABEL,
      lastNameInvalid: GENERAL_INVALID,
      lastNameLabel: LAST_NAME_LABEL,
      emailInvalid: GENERAL_INVALID,
      emailLabel: EMAIL_LABEL,
      phoneInvalid: GENERAL_INVALID,
      phoneLabel: PHONE_LABEL
    };
  },
  computed: {
    ...mapState({
      appellative: state => state.formInputs.appellative,
      position: state => state.formInputs.position,
      firstName: state => state.formInputs.firstName,
      lastName: state => state.formInputs.lastName,
      email: state => state.formInputs.email,
      phone: state => state.formInputs.phone,
      validAppellative: state => state.isFormValid.appellative,
      validPosition: state => state.isFormValid.position,
      validFirstName: state => state.isFormValid.firstName,
      validLastName: state => state.isFormValid.lastName,
      validEmail: state => state.isFormValid.email,
      validPhone: state => state.isFormValid.phone,
      contactAppellative: state => state.formInputs.contact.appellative,
      contactPosition: state => state.formInputs.contact.position,
      contactFirstName: state => state.formInputs.contact.firstName,
      contactLastName: state => state.formInputs.contact.lastName,
      contactEmail: state => state.formInputs.contact.email,
      contactPhone: state => state.formInputs.contact.phone,
      validContactAppellative: state => state.isFormValid.contact.appellative,
      validContactPosition: state => state.isFormValid.contact.position,
      validContactFirstName: state => state.isFormValid.contact.firstName,
      validContactLastName: state => state.isFormValid.contact.lastName,
      validContactEmail: state => state.isFormValid.contact.email,
      validContactPhone: state => state.isFormValid.contact.phone,
      hasContact: state => state.formInputs.hasContact
    })
  },
  methods: {
    ...mapMutations([
      "incrementWizardStep",
      "addAppellative",
      "addPosition",
      "addFirstName",
      "addLastName",
      "addEmail",
      "addPhone",
      "isAppellativeValid",
      "isPositionValid",
      "isFirstNameValid",
      "isLastNameValid",
      "isEmailValid",
      "isPhoneValid",
      "addContactAppellative",
      "addContactPosition",
      "addContactFirstName",
      "addContactLastName",
      "addContactEmail",
      "addContactPhone",
      "isContactAppellativeValid",
      "isContactPositionValid",
      "isContactFirstNameValid",
      "isContactLastNameValid",
      "isContactEmailValid",
      "isContactPhoneValid",
      "toggleHasContact",
      "setIsOwnerResponsibleCorresp"
    ]),
    setAppellative: function(value) {
      if (this.appellative !== value) this.addAppellative(value);
    },
    setPosition: function(value) {
      if (this.position !== value) this.addPosition(value);
    },
    setFirstName: function(event) {
      if (this.firstName !== event.target.value.trim())
        this.addFirstName(event.target.value.trim());
    },
    setLastName: function(event) {
      if (this.lastName !== event.target.value.trim())
        this.addLastName(event.target.value.trim());
    },
    setEmail: function(event) {
      if (this.email !== event.target.value.trim())
        this.addEmail(event.target.value.trim());
    },
    setPhone: function(event) {
      if (this.phone !== event.target.value.trim())
        this.addPhone(event.target.value.trim());
    },
    setContactAppellative: function(value) {
      if (this.contactAppellative !== value) this.addContactAppellative(value);
    },
    setContactPosition: function(value) {
      if (this.contactPosition !== value) this.addContactPosition(value);
    },
    setContactFirstName: function(event) {
      if (this.contactFirstName !== event.target.value.trim())
        this.addContactFirstName(event.target.value.trim());
    },
    setContactLastName: function(event) {
      if (this.contactLastName !== event.target.value.trim())
        this.addContactLastName(event.target.value.trim());
    },
    setContactEmail: function(event) {
      if (this.contactEmail !== event.target.value.trim())
        this.addContactEmail(event.target.value.trim());
    },
    setContactPhone: function(event) {
      if (this.contactPhone !== event.target.value.trim())
        this.addContactPhone(event.target.value.trim());
    },
    removeContact: function() {
      this.setIsOwnerResponsibleCorresp(true);
      this.toggleHasContact();
    },
    nextStep: function() {
      const isAppellativeValid = notNull(this.appellative);
      this.isAppellativeValid(isAppellativeValid);

      const isPositionValid = notNull(this.position);
      this.isPositionValid(isPositionValid);

      const isFirstNameValid = notNull(this.firstName);
      this.isFirstNameValid(isFirstNameValid);

      const isLastNameValid = notNull(this.lastName);
      this.isLastNameValid(isLastNameValid);

      const isEmailValid = validateEmail(this.email);
      this.isEmailValid(isEmailValid);

      const isPhoneValid = notNull(this.phone);
      this.isPhoneValid(isPhoneValid);

      if (
        !this.hasContact &&
        isAppellativeValid &&
        isPositionValid &&
        isFirstNameValid &&
        isLastNameValid &&
        isEmailValid &&
        isPhoneValid
      ) {
        return this.incrementWizardStep();
      }

      const isContactAppellativeValid = notNull(this.contactAppellative);
      this.isContactAppellativeValid(isContactAppellativeValid);

      const isContactPositionValid = notNull(this.contactPosition);
      this.isContactPositionValid(isContactPositionValid);

      const isContactFirstNameValid = notNull(this.contactFirstName);
      this.isContactFirstNameValid(isContactFirstNameValid);

      const isContactLastNameValid = notNull(this.contactLastName);
      this.isContactLastNameValid(isContactLastNameValid);

      const isContactEmailValid = validateEmail(this.contactEmail);
      this.isContactEmailValid(isContactEmailValid);

      const isContactPhoneValid = notNull(this.contactPhone);
      this.isContactPhoneValid(isContactPhoneValid);

      if (
        isAppellativeValid &&
        isPositionValid &&
        isFirstNameValid &&
        isLastNameValid &&
        isEmailValid &&
        isPhoneValid &&
        isContactAppellativeValid &&
        isContactPositionValid &&
        isContactFirstNameValid &&
        isContactLastNameValid &&
        isContactEmailValid &&
        isContactPhoneValid
      ) {
        this.incrementWizardStep();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  font-size: 1rem;
}

.add-new-contact {
  font-weight: 600;
}
</style>
